'use strict';

var SearchCriteriaDirective = function SearchCriteriaDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/search-criteria.html'),
    controller: 'SearchCriteriaController',
    scope: {
      screen: '=?',
      initialScreen: '@',
      defaultSearchCriteria: '=?',
      triggerSearchCallback: '&',
      defaultListing: '=',
      onlyOneCriteriaRowAllowed: '=',
      customSearchModes: '=',
      customSearchLabel: '@',
      searchModeChangeCallback: '='
    },
    link: function link(scope, element) {
      function setFocusOnDialogOpen() {
        if (scope.storedCriteria.length > 0) {
          element.find('.savedCriteria').focus();
        } else {
          element.find('.search-categories:first').focus();
        }
      }
      element.find('.gdpr-popover').popover();

      // triggered when the UI-ROUTER state changes: user clicks a button in toolbar, or transition takes place
      scope.$on('$stateChangeSuccess', scope.onStateChangeSuccess);
      scope.$on('search-criteria:forceSearch', function () {
        if (!scope.isFormDisabled()) {
          scope.triggerSearch();
          element.modal('hide');
        }
      });
      scope.$watchGroup(['screen', 'customSearchMode'], scope.handleScreenAndModeChange);
      scope.onSearchButtonClick = function () {
        if (!scope.isFormDisabled()) {
          scope.broadcastSearchButtonClick();
          if (scope.triggerSearch()) {
            element.modal('hide');
          }
        }
      };
      scope.onClearButtonClick = function () {
        if (!scope.unchangedSearchCriteria()) {
          scope.clearSearchCriteria();
        }
      };
      scope.onCancelButtonClick = function () {
        scope.loadLastSearchCriteria();
        element.modal('hide');
      };
      scope.onSaveButtonClick = function () {
        if (!scope.isSaveDisallowed()) {
          scope.checkDuplicatesAndSave();
        }
      };
      scope.$on('search-criteria:no-results', function () {
        element.modal('show');
        scope.appearNoResultsWarning();
      });
      element.on('shown.bs.modal', function () {
        scope.openDialogActions();
        setFocusOnDialogOpen();
      });
      element.on('hidden.bs.modal', function () {
        scope.dismissSuccessMessage();
        scope.closeDialogActions();
      });
    }
  };
};
SearchCriteriaDirective.$inject = [];
module.exports = SearchCriteriaDirective;